import React, { ReactNode } from 'react'
import { Wrapper, TableHeader } from './styles'

import Item from './Item'
import Preloader from '../../../Common/Preloader'

import { ListItem} from '@material-ui/core'
import { useTranslation } from 'react-i18next'

interface OutstandingsListProps {}

const OutstandingsList: React.FC<OutstandingsListProps> = () => {
  const [t] = useTranslation()


  const renderList = () => {
    return [{id: 1},{id: 2},{id: 3},{id: 4}].map((item: any, id: number) => {
      return (
        <React.Fragment key={id}>
          <Item item={item} />
        </React.Fragment>
      )
    })
  }
  interface TcProps {
    children: ReactNode
  }
  const Tc: React.FC<TcProps> = ({ children }) => {
    return (
      <ListItem component="span" style={{ justifyContent: 'center', textAlign: 'center' }}>
        {children}
      </ListItem>
    )
  }

  // const {
  //   tables: {data: tables}
  // } = useSelector(tableSelector)

  // const [page, setPage] = React.useState(1)
  // React.useEffect(() => {
  //   getCollectionList(page, 20)
  //   // eslint-disable-next-line
  // }, [page])

  return (
    <>
      <Wrapper>
        <div style={{ minWidth: '550px' }}>
          <TableHeader style={{ fontSize: '75%' }}>
            <Tc>#</Tc>
            <Tc>{t('Адрес')}</Tc>
            <Tc>{t('ru.terminals.fields.date')}</Tc>
            <Tc>{t('ru.terminals.fields.phone_number')}</Tc>
            <Tc>{t('ru.terminals.fields.amount')}</Tc>
            <Tc>{t('Пользователь')}</Tc>
            <Tc>{t('Дата выплаты')}</Tc>
            <Tc>{''}</Tc>
          </TableHeader>
          <ul className={'Terminal'}>{false ? <Preloader absolute={false} /> : renderList()}</ul>
          <Item disabled item={{id: 5}}/>
          <Item disabled item={{id: 6}}/>
         {/* {pageCount && <Box
            display="flex"
            justifyContent="center"
            style={{ margin: '10px auto', width: '100%' }}
          >
            <Pagination
              variant="outlined"
              shape="rounded"
              siblingCount={0}
              count={pageCount}
              page={page}
              onChange={(e, value) => {
                setPage(value)
              }}
            />
          </Box>} */}
        </div>
      </Wrapper>
    </>
  )
}

export default OutstandingsList
